<h1 mat-dialog-title>Audio blok configureren</h1>

<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4">
    <div class="space-y-2">
      <label for="type" class="block font-medium text-sm select-none"
        >Afspeel type</label
      >
      <mat-radio-group class="flex flex-col -ml-2.5" formControlName="type" name="type">
        @for (option of options; track $index) {
          <mat-radio-button [value]="option.value" class="py-2 select-none">
            <div>{{ option.displayValue }}</div>
            <span class="text-xs text-gray-500">{{ option.description }}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button mat-button (click)="handleConfirm()" [disabled]="submitted()">
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
